// import variables
import { CONFIRMATION_STATUS_WAITING } from 'helpers/variables';
import { PAYMENT_STATUS } from 'helpers/prices';
const { SUCCEED } = PAYMENT_STATUS;

export const GTM_TRACKING_EVENTS = {
	INTERACT_WITH_FILM: 'interact_with_film',
	CLICK_CAROUSEL: 'click_carousel',
	CLICK_BANNER: 'click_banner',
	CLICK_SEARCH_LIST: 'click_search_list',
	CLICK_SEARCH_RESULTS: 'click_search_results',
	CLICK_TV_SHOW: 'click_tvshow',
	CLICK_TELEVISION: 'click_telewizja',
	SEE_CTA: 'poznaj_CTA',
	SEE_CTA_FAQ: 'poznaj_FAQ',
	CLICK_HEADER_MENU: 'header_menu',
	REGISTER: 'registration_complete',
	LOGIN: 'login',
	PURCHASE: 'purchase'
};

// GTM TRACKING ACTIONS
export const CLICK_GTM_ACTION = 'click';
export const FORM_GTM_ACTION = 'form';
export const VIDEO_GTM_ACTION = 'video';

// GTM SEGMENTATION
export const FILM_GTM_SEGMENTATION = 'film';
export const GLOBAL_GTM_SEGMENTATION = 'global';
export const ACCOUNT_GTM_SEGMENTATION = 'account';

// GTM USER TYPES
export const EXTERNAL_GTM_USER = 'external';
export const VECTRA_GTM_USER = 'vectra';

// GTM LOGIN TYPES
export const EMAIL_GTM_LOGIN = 'email';

// GTM PAYMENT FINALIZATION ALLOWED STATUSES ARRAY
export const ALLOWED_GTM_PAYMENT_STATUSES = [
	CONFIRMATION_STATUS_WAITING,
	SUCCEED
];
